// extracted by mini-css-extract-plugin
module.exports =  {"updateFailedListingsCard":"updateFailedListingsCard__JHJ8d"};